export default "__VITE_ASSET__BYWdeD52__"